// Accessible tabs: click or arrow keys switch panels.
if (!customElements.get('mew-tabs')) {
  customElements.define(
    'mew-tabs',
    class MewTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        // Arrows scroll the visible row by one card; hidden when the row fits.
        this.arrows = this.querySelector('.mew-tabs__arrows');
        this.querySelectorAll('[data-mew-scroll]').forEach((button) =>
          button.addEventListener('click', () => this.scrollRow(Number(button.dataset.mewScroll)))
        );
        this.updateArrows();
        window.addEventListener('resize', () => this.updateArrows());
      }

      updateArrows() {
        if (!this.arrows) return;
        const grid = this.querySelector('.mew-tabs__panel:not([hidden]) .mew-tabs__grid');
        this.arrows.hidden = !grid || grid.scrollWidth <= grid.clientWidth + 1;
      }

      scrollRow(direction) {
        const grid = this.querySelector('.mew-tabs__panel:not([hidden]) .mew-tabs__grid');
        const card = grid?.querySelector('.mew-tabs__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        this.updateArrows();
        if (focus) this.tabs[index].focus();
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select(next, true);
      }
    }
  );
}
